module.exports = {
  "country": "IS",
  "artist": "Yohanna",
  "song": "Is it True?",
  "year": "2009",
  "place": "2",
  "spotify": "6O2FeioJzAJiDyf6FZFfAa"
};